var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListViewWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8052)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.78408 0.976562C2.125 0.976562 0.78125 2.28106 0.78125 3.88994V6.8001C0.78125 8.40908 2.125 9.71367 3.78408 9.71367H45.8251C47.4843 9.71367 48.8281 8.40908 48.8281 6.8001V3.88994C48.8281 2.28106 47.4843 0.976562 45.8251 0.976562H3.78408ZM3.78408 14.0803C2.125 14.0803 0.78125 15.3833 0.78125 16.9922V19.904C0.78125 21.5145 2.125 22.8159 3.78408 22.8159H45.8251C47.4843 22.8159 48.8281 21.5145 48.8281 19.904V16.9922C48.8281 15.3833 47.4843 14.0803 45.8251 14.0803H3.78408ZM3.78408 27.1825C2.125 27.1825 0.78125 28.487 0.78125 30.096V33.0061C0.78125 34.615 2.125 35.9194 3.78408 35.9194H45.8251C47.4843 35.9194 48.8281 34.615 48.8281 33.0061V30.096C48.8281 28.487 47.4843 27.1825 45.8251 27.1825H3.78408Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.78408 40.2871C2.125 40.2871 0.78125 41.5915 0.78125 43.2004V46.1105C0.78125 47.7194 2.125 49.0239 3.78408 49.0239H45.8251C47.4843 49.0239 48.8281 47.7194 48.8281 46.1105V43.2004C48.8281 41.5915 47.4843 40.2871 45.8251 40.2871H3.78408Z",
    fill: "#F9F9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8052"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListViewWhite);
export default __webpack_public_path__ + "static/media/list_view_white.ee787ea1b2a9fcc5e762f76022a0b831.svg";
export { ForwardRef as ReactComponent };